import React from 'react';
import { nameCompany } from '../../constantValues/OTHER';
import logo from '../../images/amb_logo.png';
import { Navbar } from 'react-bootstrap';
import NAV_ITEM from '../../constantValues/NAV_ITEM_PROPERTIES';
import PropTypes from 'prop-types';
import { LinkContainer } from 'react-router-bootstrap';

import keycloak from '../../helpers/keycloak';

const NavbarHeader = props => (
    <Navbar.Header>
        <Navbar.Brand className={'navbar-brand'}>
            <LinkContainer to={'/myEvent'}>
                <img
                    src={logo}
                    className={'navbar-company-logo'}
                    alt={nameCompany}
                />
            </LinkContainer>
        </Navbar.Brand>
        {props.isAuth && (
            <div
                className={'navbar-logout'}
                onClick={() => {
                    keycloak.logout();
                    sessionStorage.clear();
                    localStorage.clear();
                }}
            >
                <i className={NAV_ITEM.logout.className} />
            </div>
        )}
        {props.isAuth && <Navbar.Toggle className={'navbar-toggle'} />}
    </Navbar.Header>
);

NavbarHeader.propTypes = {
    isAuth: PropTypes.bool,
    keycloak: PropTypes.object
};

export default NavbarHeader;



// WEBPACK FOOTER //
// ./src/components/Navbar/NavbarHeader.js